/* Koepelcoach (03-11-2026): chat-adviseur met livechat-overname.
   Gesprek blijft 48 uur bewaard in localStorage, zodat het meeloopt naar de volgende pagina. */
(() => {
  const root = document.getElementById('kc');
  if (!root) return;
  const API = root.dataset.api;
  const $ = (s) => root.querySelector(s);
  const knop = $('.kc__knop'), paneel = $('.kc__paneel'), log = $('[data-kc-log]'), chips = $('[data-kc-chips]');
  const vorm = $('[data-kc-vorm]'), veld = $('#kc-vraag'), stuur = vorm.querySelector('.kc__stuur');
  const contact = $('[data-kc-contact]'), contactTekst = $('[data-kc-contacttekst]'), mensKnop = $('[data-kc-mens]'), status = $('[data-kc-status]'), naam = $('[data-kc-naam]'), stip = $('.kc__stip');
  const SLEUTEL = 'olk-kc', DUUR = 48 * 3600e3;
  const meet = (event, extra) => { try { (window.dataLayer = window.dataLayer || []).push({ event, ...extra }); } catch (e) {} };
  const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g, () => (Math.random() * 16 | 0).toString(16)));

  let S = null;
  try { S = JSON.parse(localStorage.getItem(SLEUTEL)); } catch (e) {}
  if (!S || Date.now() - S.ts > DUUR) S = { id: uuid(), turns: [], modus: 'bot', na: 0, ts: Date.now(), open: false };
  const bewaar = () => { S.ts = Date.now(); try { localStorage.setItem(SLEUTEL, JSON.stringify({ ...S, turns: S.turns.slice(-40) })); } catch (e) {} };

  const post = async (body) => {
    const r = await fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ gesprek: S.id, pagina: location.pathname, ...body }) });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw Object.assign(new Error(j.fout || r.status), { code: j.fout || 'storing' });
    return j;
  };

  /* ---------- tekst opmaken: veilig, alleen eigen links, kaarten uit de server ---------- */
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const kaartHtml = (k) => `<div class="kc__kaart"><div class="kc__maat">${esc(k.maat || '').replace('×', '<br>×')}</div><div class="kc__kt">${esc(k.titel)}</div><div class="kc__ks">${esc(k.sub)}${k.voorraad === false ? ' · op aanvraag' : ''}</div><div class="kc__kp">${esc(k.prijs)}</div><div class="kc__knoppen">${k.variant ? `<button type="button" class="kc__bestel" data-kc-mand="${Number(k.variant)}">In winkelwagen</button>` : ''}<a class="${k.variant ? 'kc__bekijk' : 'kc__bestel'}" href="${esc(k.url)}" data-kc-kaart>${k.variant ? 'Bekijk' : 'Bekijk en bestel'}</a></div></div>`;
  function opmaak(tekst, kaarten) {
    const lijst = [];
    let s = String(tekst).replace(/\[\[maat:[^\]]*\]\]/gi, (code) => { const k = (kaarten || []).find((x) => x.code === code); if (!k) return ''; lijst.push(kaartHtml(k)); return `\u0000${lijst.length - 1}\u0000`; });
    s = s.replace(/\[\[variant:[^\]]*\]\]/gi, (code) => { const k = (kaarten || []).find((x) => x.code === code); if (!k) return ''; lijst.push(kaartHtml(k)); return `\u0000${lijst.length - 1}\u0000`; });
    s = esc(s).replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')
      .replace(/\[([^\]]+)\]\((https:\/\/(?:www\.)?onlinelichtkoepel\.nl[^)\s]*|\/[^)\s]*)\)/g, '<a href="$2">$1</a>')
      .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
    const uit = []; let ul = null;
    for (const regel of s.split('\n')) {
      const li = regel.match(/^\s*[-*•]\s+(.*)/);
      if (li) { (ul = ul || []).push(`<li>${li[1]}</li>`); continue; }
      if (ul) { uit.push(`<ul>${ul.join('')}</ul>`); ul = null; }
      if (regel.trim()) uit.push(`<p>${regel}</p>`);
    }
    if (ul) uit.push(`<ul>${ul.join('')}</ul>`);
    return uit.join('').replace(/<p>\u0000(\d+)\u0000<\/p>|\u0000(\d+)\u0000/g, (_, a, b) => lijst[+(a ?? b)]);
  }
  const VAN = { medewerker: 'Medewerker onlinelichtkoepel', coach: '' };
  function teken(t) {
    const d = document.createElement('div');
    d.className = `kc__msg kc__msg--${t.van}`;
    d.innerHTML = (VAN[t.van] ? `<span class="kc__van">${VAN[t.van]}</span>` : '') + (t.van === 'klant' || t.van === 'systeem' ? `<p>${esc(t.tekst).replace(/^\[foto\] /, '📷\u00a0')}</p>` : opmaak(t.tekst, t.kaarten));
    log.appendChild(d); log.scrollTop = log.scrollHeight;
    return d;
  }
  function voeg(t) { S.turns.push(t); bewaar(); return teken(t); }
  function denk() { const d = document.createElement('div'); d.className = 'kc__msg kc__msg--coach'; d.innerHTML = '<span class="kc__denk" aria-label="Even denken"><i></i><i></i><i></i></span>'; log.appendChild(d); log.scrollTop = log.scrollHeight; return d; }

  /* ---------- start: welkom en suggesties per paginasoort ---------- */
  const soort = root.dataset.soort, product = root.dataset.product;
  const CHIPS = soort === 'product'
    ? ['Welke maat heb ik nodig?', 'Hoeveel wanden voor mijn ruimte?', 'Past dit op mijn oude opstand?']
    : soort === 'cart'
      ? ['Mis ik nog iets voor de montage?', 'Wanneer wordt het bezorgd?', 'Klopt mijn maat?']
      : ['Mijn oude koepel is buiten 116 x 116', 'Welke koepel boven de badkamer?', 'Ik maak een nieuw dakgat', 'Helder of opaal?'];
  function welkom() {
    log.innerHTML = '';
    if (!S.turns.length) teken({ van: 'coach', tekst: product
      ? `Hallo, ik ben de Koepelcoach. Twijfelt u over de ${product.toLowerCase()}? Geef me de maat van uw opstand of oude koepel, dan reken ik het even voor u uit.`
      : 'Hallo, ik ben de Koepelcoach. Oude koepel vervangen, nieuw gat in het dak of gewoon even sparren? Met een maat of de ruimte kom ik al een heel eind.' });
    S.turns.forEach(teken);
    zetChips();
    zetModus(S.modus);
  }
  function zetChips() {
    chips.innerHTML = '';
    if (S.turns.length || S.modus !== 'bot') return;
    CHIPS.forEach((t) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'kc__chip'; b.textContent = t; b.onclick = () => vraag(t); chips.appendChild(b); });
  }

  /* ---------- modus: bot, wacht (op medewerker), open (medewerker in gesprek), bericht (terugbellen) ---------- */
  let wachtTimer = null;
  function zetModus(m) {
    S.modus = m; bewaar();
    const live = m === 'wacht' || m === 'open';
    naam.textContent = m === 'open' ? 'Medewerker onlinelichtkoepel' : 'Koepelcoach';
    status.innerHTML = '<i class="kc__live' + (m === 'bericht' ? ' is-uit' : '') + '" aria-hidden="true"></i>' + (m === 'wacht' ? 'Een collega komt eraan…' : m === 'open' ? 'U chat nu met een medewerker' : m === 'bericht' ? 'Laat een bericht achter' : 'Online · antwoord direct');
    mensKnop.hidden = live || m === 'bericht';
    contact.hidden = m !== 'bericht';
    vorm.hidden = m === 'bericht';
    veld.placeholder = live ? 'Typ uw bericht' : 'Uw vraag of een foto';
    clearTimeout(wachtTimer);
    // Na 2 minuten zonder medewerker: e-mailadres vragen, het antwoord komt dan per mail (Thom 03-11)
    const al = S.wachtSinds ? Date.now() - S.wachtSinds : 0;
    if (m === 'wacht') wachtTimer = setTimeout(() => { if (S.modus === 'wacht' && !S.contactGegeven) { voeg({ van: 'systeem', tekst: 'Het is even druk. Laat uw e-mailadres achter, dan mailen wij u het antwoord. Blijven wachten mag ook.' }); contact.hidden = false; contactTekst.textContent = 'Wij mailen u zo snel mogelijk, uiterlijk de volgende werkdag.'; } }, Math.max(1e3, 120e3 - al));
    if (m === 'wacht' && !S.wachtSinds) { S.wachtSinds = Date.now(); bewaar(); }
    if (m !== 'wacht') S.wachtSinds = 0;
    if (live) peil();
  }

  /* ---------- foto (v2): verkleinen naar max. 1280 px JPEG, pas versturen met de volgende vraag ---------- */
  const fotoVeld = $('[data-kc-foto]'), fotoKnop = fotoVeld && fotoVeld.closest('.kc__foto');
  let foto = null;
  async function verklein(bestand) {
    const img = await createImageBitmap(bestand, { imageOrientation: 'from-image' }).catch(() => null);
    if (!img) throw new Error('foto');
    const s = Math.min(1, 1280 / Math.max(img.width, img.height));
    const c = document.createElement('canvas'); c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', 0.82);
  }
  if (fotoVeld) fotoVeld.addEventListener('change', async () => {
    const f = fotoVeld.files && fotoVeld.files[0]; fotoVeld.value = '';
    if (!f) return;
    try { foto = await verklein(f); fotoKnop.classList.add('is-klaar'); meet('koepelcoach_foto');
      if (!veld.value.trim()) vraag('Wat ziet u op deze foto, en wat heb ik nodig?'); else veld.focus(); }
    catch (e) { foto = null; teken({ van: 'systeem', tekst: 'Deze foto kon ik niet openen. Probeer een andere, bijvoorbeeld een JPG.' }); }
  });

  /* ---------- vervolgknoppen (v2) ---------- */
  function zetVervolg(lijst) {
    chips.innerHTML = ''; chips.classList.toggle('kc__chips--vervolg', !!(lijst && lijst.length));
    (lijst || []).forEach((t) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'kc__chip'; b.textContent = t; b.onclick = () => { meet('koepelcoach_vervolg'); vraag(t); }; chips.appendChild(b); });
  }
  /* ---------- wat de bezoeker kiest in de samensteller (v2): staat in het webadres en het samenvattingsblok ---------- */
  function keuze() {
    const q = new URLSearchParams(location.search), uit = {};
    ['maat', 'isolatie', 'licht', 'route'].forEach((k) => { if (q.get(k)) uit[k] = q.get(k); });
    const sam = document.querySelector('[data-summary]'); if (sam && sam.innerText.trim()) uit.samenvatting = sam.innerText.replace(/\s+/g, ' ').trim().slice(0, 160);
    return Object.keys(uit).length ? uit : undefined;
  }

  /* ---------- vraag aan de coach ---------- */
  let bezig = false;
  async function vraag(tekst) {
    tekst = String(tekst || '').trim();
    if (!tekst || bezig) return;
    chips.innerHTML = '';
    if (S.modus === 'wacht' || S.modus === 'open') {
      voeg({ van: 'klant', tekst }); veld.value = '';
      post({ actie: 'stuur', tekst }).catch(() => voeg({ van: 'systeem', tekst: 'Uw bericht kwam niet aan. Probeer het opnieuw of stuur ons een bericht via /pages/contact.' }));
      return;
    }
    bezig = true; stuur.disabled = true; veld.value = ''; groei();
    const metFoto = foto; foto = null; if (fotoKnop) fotoKnop.classList.remove('is-klaar');
    const bel = voeg({ van: 'klant', tekst: (metFoto ? '[foto] ' : '') + tekst });
    if (metFoto) { const im = new Image(); im.src = metFoto; im.className = 'kc__fotomini'; im.alt = 'Uw foto'; bel.querySelector('p').prepend(im); bel.querySelector('p').lastChild.textContent = tekst; }
    meet('koepelcoach_vraag');
    const d = denk();
    try {
      const berichten = S.turns.filter((t) => t.van === 'klant' || t.van === 'coach').slice(-12).map((t) => ({ rol: t.van, tekst: t.tekst }));
      if (metFoto) d.querySelector('.kc__denk').setAttribute('aria-label', 'Even naar uw foto kijken');
      const j = await post({ berichten: berichten.map((b) => ({ ...b, tekst: b.tekst.replace(/^\[foto\] /, '') })), ...(await bezoeker()), keuze: keuze(), ...(metFoto ? { foto: metFoto } : {}) });
      d.remove();
      voeg({ van: 'coach', tekst: j.antwoord, kaarten: j.kaarten });
      zetVervolg(j.vervolg);
    } catch (e) {
      d.remove();
      teken({ van: 'systeem', tekst: e.code === 'te_veel' ? 'Even te veel vragen achter elkaar. Probeer het zo opnieuw.' : e.code === 'foto' ? 'Deze foto is te groot of geen geldig beeld. Probeer een andere.' : 'Dat lukte even niet. Probeer het opnieuw, of klik op "Praat met een medewerker".' });
    } finally { bezig = false; stuur.disabled = false; }
  }

  /* ---------- wat de coach van de bezoeker weet: product op de pagina en de winkelwagen ---------- */
  async function bezoeker() {
    const uit = { product: product || '', variant: new URLSearchParams(location.search).get('variant') || '' };
    try {
      const c = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      uit.winkelwagen = (c.items || []).slice(0, 15).map((i) => ({ titel: i.title, variant_id: i.variant_id, aantal: i.quantity, prijs: i.final_price }));
    } catch (e) {}
    return uit;
  }
  async function inMand(knopEl) {
    const id = Number(knopEl.dataset.kcMand); if (!id) return;
    knopEl.disabled = true; knopEl.textContent = 'Toevoegen…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1, properties: { _bron: 'Koepelcoach' } }] }) });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'mislukt');
      const c = await fetch('/cart.js').then((x) => x.json()).catch(() => null);
      if (c) document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = !c.item_count; });
      knopEl.textContent = 'Toegevoegd ✓';
      meet('koepelcoach_in_mand', { kc_variant: id });
      const a = document.createElement('a'); a.href = '/cart'; a.className = 'kc__bekijk'; a.textContent = 'Naar winkelwagen';
      knopEl.parentNode.querySelector('.kc__bekijk, a')?.replaceWith(a);
    } catch (e) { knopEl.disabled = false; knopEl.textContent = 'In winkelwagen'; teken({ van: 'systeem', tekst: 'Toevoegen lukte niet: ' + e.message + '. Probeer het via de productpagina.' }); }
  }

  /* ---------- naar een medewerker ---------- */
  mensKnop.addEventListener('click', async () => {
    meet('koepelcoach_mens');
    mensKnop.hidden = true;
    try {
      const j = await post({ actie: 'mens' });
      if (j.open) { voeg({ van: 'systeem', tekst: 'Ik haal er een collega bij. Die ziet ons gesprek, dus u hoeft niets te herhalen.' }); zetModus('wacht'); }
      else { voeg({ van: 'systeem', tekst: 'We zijn nu niet op kantoor (ma-vr 8.00-17.00). Laat uw e-mailadres achter, dan mailen wij u de volgende werkdag.' }); zetModus('bericht'); }
    } catch (e) { mensKnop.hidden = false; teken({ van: 'systeem', tekst: 'Dat lukte niet. Stuur ons gerust een bericht via /pages/contact.' }); }
  });
  contact.addEventListener('submit', async (e) => {
    e.preventDefault();
    const n = contact.naam.value.trim(), c = contact.contact.value.trim();
    if (!c) return contact.contact.focus();
    try {
      await post({ actie: 'contact', naam: n, contact: c });
      meet('koepelcoach_terugbellen');
      voeg({ van: 'systeem', tekst: `Dank u${n ? ' ' + n : ''}. U krijgt ons antwoord op ${c}. ${S.modus === 'wacht' ? 'Komt er nu toch iemand vrij, dan ziet u dat hier.' : ''}`.trim() });
      S.contactGegeven = true; bewaar();
      contact.reset(); contact.hidden = true;
      zetModus(S.modus === 'wacht' ? 'wacht' : 'bot');
    } catch (err) { teken({ van: 'systeem', tekst: 'Versturen lukte niet. Stuur ons gerust een bericht via /pages/contact.' }); }
  });

  /* ---------- berichten van de medewerker ophalen ---------- */
  let peilTimer = null;
  async function peil() {
    clearTimeout(peilTimer);
    if (S.modus !== 'wacht' && S.modus !== 'open') return;
    try {
      const j = await post({ actie: 'nieuw', na: S.na });
      for (const b of j.berichten || []) { S.na = Math.max(S.na, b.id); voeg({ van: b.van, tekst: b.tekst }); if (!S.open) stip.hidden = false; }
      if (j.status === 'open' && S.modus === 'wacht') zetModus('open');
      else if (j.status === 'gesloten' || j.status === 'bot') { S.contactGegeven = false; zetModus('bot'); return; }
    } catch (e) {}
    peilTimer = setTimeout(peil, document.hidden ? 15e3 : S.open ? 3e3 : 8e3);
  }

  /* ---------- open en dicht ---------- */
  function open(aan) {
    S.open = aan; bewaar();
    root.classList.toggle('is-open', aan);
    paneel.hidden = !aan; knop.setAttribute('aria-expanded', String(aan));
    if (aan) { stip.hidden = true; meet('koepelcoach_open'); setTimeout(() => (vorm.hidden ? contact.naam : veld).focus({ preventScroll: true }), 50); log.scrollTop = log.scrollHeight; if (matchMedia('(max-width:749px)').matches) document.documentElement.style.overflow = 'hidden'; }
    else { document.documentElement.style.overflow = ''; knop.focus({ preventScroll: true }); }
  }
  knop.addEventListener('click', () => open(true));

  /* ---------- online-bolletje en praatwolkje (03-11) ---------- */
  const kantoor = () => { try { const nu = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' })); const d = nu.getDay(), u = nu.getHours(); return d >= 1 && d <= 5 && u >= 8 && u < 17; } catch (e) { return true; } };
  // De coach antwoordt altijd; buiten kantoortijd is alleen de medewerker er niet. Het bolletje blijft dus groen.
  const wolk = $('[data-kc-wolk]');
  const wolkWeg = (bewaarIt) => { wolk.hidden = true; if (bewaarIt) try { sessionStorage.setItem('olk-kc-wolk', '1'); } catch (e) {} };
  $('[data-kc-wolk-open]').addEventListener('click', () => { wolkWeg(true); meet('koepelcoach_wolk_klik'); open(true); });
  $('[data-kc-wolk-weg]').addEventListener('click', () => wolkWeg(true));
  let wolkGezien = false; try { wolkGezien = sessionStorage.getItem('olk-kc-wolk') === '1'; } catch (e) {}
  if (!wolkGezien && !S.open && !S.turns.length) {
    setTimeout(() => { if (!S.open && !root.hidden) { wolk.hidden = false; meet('koepelcoach_wolk'); setTimeout(() => wolkWeg(false), 15e3); } }, 3500);
  }
  if (!kantoor()) status.dataset.uit = '1';
  $('.kc__dicht').addEventListener('click', () => open(false));
  root.addEventListener('keydown', (e) => { if (e.key === 'Escape' && S.open) open(false); });
  log.addEventListener('click', (e) => {
    const m = e.target.closest('[data-kc-mand]'); if (m) return inMand(m);
    const a = e.target.closest('[data-kc-kaart]'); if (a) meet('koepelcoach_kaart_klik', { kc_url: a.getAttribute('href') });
  });
  vorm.addEventListener('submit', (e) => { e.preventDefault(); vraag(veld.value); });
  const groei = () => { veld.style.height = 'auto'; veld.style.height = Math.min(veld.scrollHeight, 120) + 'px'; };
  veld.addEventListener('input', groei);
  veld.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); vraag(veld.value); } });

  /* ---------- plek: boven koopbalk en mandbalk, weg zolang de cookiebanner open staat ---------- */
  function plek() {
    let onder = 16;
    document.querySelectorAll('.olk-koopbalk:not([hidden]), .olk-mand-balk, .buybar.is-visible').forEach((el) => {
      const r = el.getBoundingClientRect(), st = getComputedStyle(el);
      if (st.position === 'fixed' && st.display !== 'none' && r.height && r.bottom >= innerHeight - 2 && r.top < innerHeight) onder = Math.max(onder, innerHeight - r.top + 12);
    });
    root.style.setProperty('--kc-onder', onder + 'px');
    const cookie = document.getElementById('cookiescript_injected');
    const cookieOpen = cookie && getComputedStyle(cookie).display !== 'none' && cookie.getBoundingClientRect().height > 0;
    root.hidden = !!cookieOpen && !S.open;
  }
  addEventListener('scroll', plek, { passive: true });
  addEventListener('resize', plek);
  new MutationObserver(plek).observe(document.body, { childList: true, subtree: false, attributes: false });
  setInterval(plek, 1500);

  welkom();
  plek();
  if (S.open && !matchMedia('(max-width:749px)').matches) open(true);
  if (S.modus === 'wacht' || S.modus === 'open') peil();
})();
